docReady(function () {

	let headers = document.querySelectorAll('.header');
	let mobileQuery = window.matchMedia('(max-width: 991px)');
	let scrollPosition = 0;

	headers.forEach(function (header) {
		let burger = header.querySelector('.header__burger');
		let panel = header.querySelector('.header__panel');
		let logo = header.querySelector('.header__logo');
		let updateTopState = function () {
			let isDesktop = !mobileQuery.matches;
			let isAtTop = (window.scrollY || document.documentElement.scrollTop || 0) <= 0;

			header.classList.toggle('is-at-top', isDesktop && isAtTop);
		};

		if (!burger || !panel) {
			return;
		}

		updateTopState();
		window.addEventListener('scroll', updateTopState, { passive: true });

		burger.addEventListener('click', function () {
			let isOpen = header.classList.toggle('is-open');

			burger.classList.toggle('active', isOpen);
			panel.classList.toggle('active', isOpen);
			burger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
			setPageScrollLock(isOpen);
			setHeaderLogo(logo, isOpen);

			if (!isOpen) {
				resetMegaMenu(header);
			}
		});

		mobileQuery.addEventListener('change', function (event) {
			updateTopState();

			if (event.matches || !header.classList.contains('is-open')) {
				return;
			}

			header.classList.remove('is-open');
			burger.classList.remove('active');
			panel.classList.remove('active');
			burger.setAttribute('aria-expanded', 'false');
			setPageScrollLock(false);
			setHeaderLogo(logo, false);
			resetMegaMenu(header);
		});

		header.querySelectorAll('.header-nav__item.has-megamenu').forEach(function (menuItem) {
			let menuLink = menuItem.querySelector(':scope > .header-nav__link');
			let megaMenu = menuItem.querySelector(':scope > .header-nav-sub.megamenu');

			if (!menuLink || !megaMenu) {
				return;
			}

			let sections = megaMenu.querySelectorAll('[data-mega-menu-section]');

			sections.forEach(function (section) {
				let backButton = section.querySelector('[data-mega-menu-back]');

				section.addEventListener('mouseenter', function () {
					if (!mobileQuery.matches) {
						setActiveSection(megaMenu, section);
					}
				});

				section.addEventListener('focusin', function () {
					if (!mobileQuery.matches) {
						setActiveSection(megaMenu, section);
					}
				});

				if (backButton) {
					backButton.addEventListener('click', function () {
						section.classList.remove('is-mobile-active');
					});
				}
			});

			menuLink.addEventListener('click', function (event) {
				if (!mobileQuery.matches) {
					return;
				}

				event.preventDefault();
			});

			let topLevelToggle = megaMenu.querySelector('[data-mega-menu-mobile-toggle]');

			if (topLevelToggle) {
				topLevelToggle.addEventListener('click', function () {
					if (!mobileQuery.matches) {
						return;
					}

					let isOpen = megaMenu.classList.toggle('is-mobile-expanded');

					topLevelToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
				});
			}
		});
	});

	function setPageScrollLock(isOpen) {
		if (isOpen) {
			scrollPosition = window.scrollY || document.documentElement.scrollTop || 0;
			document.documentElement.classList.add('has-mobile-menu-open');
			document.body.classList.add('has-mobile-menu-open');
			document.body.style.top = `-${scrollPosition}px`;
			return;
		}

		document.documentElement.style.scrollBehavior = 'auto';
		document.documentElement.classList.remove('has-mobile-menu-open');
		document.body.classList.remove('has-mobile-menu-open');
		document.body.style.top = '';
		window.scrollTo(0, scrollPosition);

		requestAnimationFrame(function () {
			document.documentElement.style.scrollBehavior = '';
		});
	}

	function setHeaderLogo(logo, isOpen) {
		if (!logo) {
			return;
		}

		let logoSrc = isOpen ? logo.dataset.openSrc : logo.dataset.defaultSrc;

		if (logoSrc) {
			logo.src = logoSrc;
		}
	}

	function setActiveSection(megaMenu, activeSection) {
		megaMenu.querySelectorAll('[data-mega-menu-section]').forEach(function (section) {
			section.classList.toggle('is-active', section === activeSection);
		});
	}

	function resetMegaMenu(header) {
		header.querySelectorAll('.header-nav-sub.megamenu').forEach(function (megaMenu) {
			megaMenu.querySelectorAll('.is-mobile-active').forEach(function (section) {
				section.classList.remove('is-mobile-active');
			});
			megaMenu.classList.remove('is-mobile-expanded');
			megaMenu.querySelectorAll('[data-mega-menu-mobile-toggle]').forEach(function (toggle) {
				toggle.setAttribute('aria-expanded', 'false');
			});
		});
	}

});
